var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-container"},[_c('img',{style:(_vm.iconStyle),attrs:{"src":_vm.icon,"alt":_vm.tip}}),_c('p',{style:(_vm.tipStyle)},[_vm._v(_vm._s(_vm.tip))])])}
var staticRenderFns = []

export { render, staticRenderFns }